import React from 'react';

export function KGMark({ size = 40 }: { size?: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width={size} height={size} role="img" aria-label="KG Manager">
      <g fill="none" stroke="#C79BFA" strokeWidth="2" strokeLinecap="round">
        <path d="M13.6 11.5 L8.9 18.9" />
        <path d="M18.4 11.5 L23.1 18.9" />
        <path d="M9.92 24.11 L14.05 27.09" />
        <path d="M23.08 24.11 L17.95 27.09" />
      </g>
      <rect x="11.5" y="3" width="9" height="9" rx="2.8" fill="rgba(255,255,255,0.42)" />
      <circle cx="7" cy="22" r="3.6" fill="rgba(255,255,255,0.42)" />
      <circle cx="25" cy="22" r="3.6" fill="rgba(255,255,255,0.42)" />
      <circle cx="16" cy="28.5" r="2.4" fill="#B478F5" />
    </svg>
  );
}

export function PollyMark() {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" aria-hidden="true">
      <rect width="26" height="26" rx="7" fill="#8E42EE" />
      <path
        d="M13 6.5L18.5 10v6L13 19.5 7.5 16v-6L13 6.5z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle cx="13" cy="13" r="2.5" fill="white" />
    </svg>
  );
}

export function PollyLogo({ size = 28 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={Math.round(size * 19 / 16)}
      viewBox="0 0 16 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Polly"
    >
      <path
        d="M11.6812 14.5209C11.3222 14.7453 10.8567 14.6249 10.64 14.2517C10.4247 13.8776 10.5402 13.3925 10.8984 13.1667L14.7738 10.7409C15.0384 10.5752 15.2 10.2792 15.2 9.96004V7.90016C15.2 7.75776 15.049 7.6701 14.9309 7.74398L11.6812 9.7772C11.3202 10.0002 10.8541 9.87611 10.64 9.50002C10.4247 9.12594 10.5402 8.64084 10.8984 8.41506L14.8591 5.93589C15.0707 5.80338 15.2 5.56656 15.2 5.31122V5.14435C15.1988 4.2451 14.7105 3.42363 13.9384 3.02196L8.6184 0.250172C7.9772 -0.0833906 7.2228 -0.0833906 6.5816 0.250172L1.2616 3.02196C0.489491 3.42363 0.00118006 4.2451 0 5.14435V13.8557C0.00118006 14.7549 0.489491 15.5764 1.2616 15.9781L6.5816 18.7499C7.2228 19.0834 7.9772 19.0834 8.6184 18.7499L13.9384 15.9781C14.7105 15.5764 15.1988 14.7549 15.2 13.8557V12.9751C15.2 12.6906 14.8985 12.5152 14.6623 12.6625L11.6812 14.5209Z"
        fill="white"
      />
    </svg>
  );
}

export function CheckCircleIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <circle cx="8" cy="8" r="7.25" stroke="#8E42EE" strokeWidth="1.5" />
      <path d="M5 8l2 2 4-4" stroke="#8E42EE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function CheckSmallIcon() {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
      <path d="M2 5l2.5 2.5 3.5-4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function ArrowRightIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function ErrorIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <circle cx="7" cy="7" r="6.25" stroke="currentColor" strokeWidth="1.5" />
      <path d="M7 4v3.5M7 9.5v.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function EnvIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <rect x="1" y="3" width="12" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.25" />
      <path d="M4 7h2M8 7h2M4 9.5h6" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  );
}

export function SpinnerIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="lp-spin" aria-hidden="true">
      <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="2" strokeOpacity="0.25" />
      <path d="M8 2a6 6 0 016 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
